<header class="flex header">
  <h2>{{ 'InventorySession_CreateChild' | translateWF: 'Create Child Session' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" [disabled]="isSaving" />
</header>

@if (isLoadingLocations) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}

<section class="content">
  <p-card>
    <div class="col">
      <div class="form-box">
        <label>{{ 'InventorySession_ParentLocation' | translateWF: 'Parent Location' }}</label>
        <span class="font-semibold">{{ parentLocationCode }}</span>
      </div>

      <div class="form-box">
        <label>{{ 'InventorySession_SelectChildLocation' | translateWF: 'Select Location' }}</label>
        <p-treeSelect
          class="w-full"
          [options]="locationTreeNodes"
          [(ngModel)]="selectedNode"
          selectionMode="single"
          [placeholder]="'InventorySession_SelectLocation' | translateWF: 'Select a location'"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          [fluid]="true"
          panelStyleClass="[&_.p-tree-node-leaf>"
          [loading]="isLoadingLocations"
          (onShow)="matchPanelWidth($event)"
        />
      </div>
    </div>
  </p-card>
</section>

<footer>
  <p-button class="w-full" [label]="'Common_Create' | translateWF: 'Create'" (click)="onSave()" [disabled]="!selectedNode || isSaving" [loading]="isSaving" />
  <p-button class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" [disabled]="isSaving" />
</footer>
